/**
 * @author Artem Lytvynov
 * @copyright Artem Lytvynov
 * @license Apache-2.0
 */

export enum DT_UNIT_VALUES {
  SECOND = "second",
  MILLISECOND = "millisecond",
  MICROSECOND = "microsecond",
  NANOSECOND = "nanosecond",
}
